<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Användare'" :sub-title="user_name" :title-id="user_id"></limitless-page-header>

        <div class="content">
            <div v-if="busy_loading">
                <i class="icon-spinner2 spinner"></i>
            </div>
            <div v-else-if="user">
                <ValidationObserver ref="userform">
                    <form @submit.prevent="saveUser">
                        <div v-if="user.deleted_at" class="alert alert-danger">Denna användare är inaktiverad.</div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="card">
                                    <div class="card-header bg-white">
                                        <h5 class="card-title">Användarinformation</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Namn: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="name" name="Namn" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="user.name" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">E-post: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="email" name="E-post" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="user.email" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Administratör:</label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="admin" name="admin" rules="" v-slot="{ errors }">
                                                    <div class="form-check">
                                                        <label class="form-check-label" style="padding-top: 8px;">
                                                            <input type="checkbox" class="form-check-input" v-model="user.admin" :true-value="1" :false-value="0">
                                                            Är administratör
                                                        </label>
                                                    </div>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-header border-top bg-white">
                                        <h5 class="card-title">Nytt lösenord</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Lösenord: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="password" name="Lösenord" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="password" class="form-control" v-model="user.password" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Bekräfta: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="password_confirm" name="Lösenordsbekräftelse" rules="confirmed:password" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="password" class="form-control" v-model="user.password_confirm" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-footer">
                                        <div class="d-flex">
                                            <limitless-button
                                                v-if="user.id > 0"
                                                ref="btndeleteuser"
                                                type="button"
                                                @click="deleteUser"
                                                :busy="busy_saving"
                                                :icon="(user.deleted_at ? 'icon-reload-alt' : 'icon-cross2')"
                                                btn-class="btn-danger"
                                                saved-text="OK"
                                            >
                                                {{ (user.deleted_at ? 'Återaktivera användare' : 'Inaktivera användare') }}
                                            </limitless-button>
                                            <limitless-button ref="btnsaveuser" type="button" class="ml-auto" @click="saveUser" :busy="busy_saving" icon="icon-floppy-disk">Spara</limitless-button>
                                        </div>
                                    </div>
                                </div> <!-- /card -->
                            </div> <!-- /col -->
                            <div class="col-lg-6">
                            </div>
                        </div> <!-- /row -->
                    </form>
                </ValidationObserver>
            </div>
            <div v-else>
                <i class="text-danger">Kunde inte ladda data</i>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import { getError } from '@services/Helpers';

export default {
    name: 'UserEdit',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
    },
    props: {
        id: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        user: null,
    }),
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            const vm = this;
            vm.busy_loading = true;
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    vm.user = response.data.user;
                })
                .finally(() => {
                    vm.busy_loading = false;
                });
        },
        async saveUser() {
            const vm = this;
            const isValid = await this.$refs.userform.validate();
            if (isValid) {
                vm.busy_saving = true;
                await apiClient.post('/vue/users/' + vm.id + '', vm.user)
                    .then((response) => {
                        if (vm.id !== response.data.user.id) {
                            window.location.href = '/users/' + response.data.user.id;
                        }
                        vm.user = response.data.user;
                        vm.$refs.btnsaveuser.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.userform.setErrors(parsederror);
                        }
                        vm.$refs.btnsaveuser.triggerFailed();
                    })
                    .finally(() => {
                        vm.busy_saving = false;
                    });
            }
        },
        deleteUser() {
            const vm = this;
            if (this.user.deleted_at) {
                // eslint-disable-next-line no-restricted-globals, no-alert
                if (confirm('Är du säker på att du vill återaktivera denna användare?')) {
                    this.busy_saving = true;
                    apiClient.post('/vue/users/' + this.id + '/restore')
                        .then(() => {
                            this.getUser();
                            this.$refs.btndeleteuser.triggerSuccess();
                        })
                        .catch(() => {
                            this.$refs.btndeleteuser.triggerFailed();
                        })
                        .finally(() => {
                            this.busy_saving = false;
                        });
                }
                // eslint-disable-next-line no-restricted-globals,no-alert
            } else if (confirm('Är du säker på att du vill inaktivera denna användare?')) {
                vm.busy_saving = true;
                apiClient.delete('/vue/users/' + this.id)
                    .then(() => {
                        this.getUser();
                        this.$refs.btndeleteuser.triggerSuccess();
                    })
                    .catch(() => {
                        this.$refs.btndeleteuser.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    watch: {

    },
    computed: {
        user_name() {
            return (this.user && this.user.id > 0 ? this.user.name : 'Ny användare');
        },
        user_id() {
            return (this.user && this.user.id > 0 ? this.user.id : '');
        },
    },
};
</script>
